module.exports = __webpack_public_path__ + "r-v3/img/bad.9bac16c2.svg";